import { USER_TYPES } from '../../enums/user-types.enum';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class UserTypeService {
	static isSupervisor(userTypeId: number): boolean {
		return userTypeId === USER_TYPES.Supervisor || userTypeId === USER_TYPES.FranchiseOperator;
	}

	static isParticipant(userTypeId: number): boolean {
		return userTypeId === USER_TYPES.Participant;
	}

	static isClientAdmin(userTypeId: number): boolean {
		return userTypeId === USER_TYPES.ClientAdministrativeAccess;
	}

	static isAdmin(userTypeId: number): boolean {
		return userTypeId === USER_TYPES.Administrator;
	}

	static isApplicationTeam(userTypeId: number): boolean {
		return userTypeId === USER_TYPES.ApplicationTeam;
	}

	static isInternalAdmin(userTypeId: number): boolean {
		const externalUserTypes = [
			USER_TYPES.Participant,
			USER_TYPES.RestrictedParticipant,
			USER_TYPES.Supervisor,
			USER_TYPES.ClientAdministrativeAccess,
			USER_TYPES.ProxyApplicationCreator,
			USER_TYPES.FranchiseOperator,
			USER_TYPES.FranchiseProxy,
			USER_TYPES.FranchiseLiaison
		];

		return !externalUserTypes.includes(userTypeId);
	}

	static isFranchiseOperator(userTypeId: number): boolean {
		const franchiseOperator = [USER_TYPES.FranchiseOperator];

		return franchiseOperator.includes(userTypeId);
	}

	static isFranchiseOperatorLiaison(userTypeId: number): boolean {
		const franchiseOperatorLiaison = [USER_TYPES.FranchiseOperator, USER_TYPES.FranchiseLiaison];

		return franchiseOperatorLiaison.includes(userTypeId);
	}

	static isFranchiseOperatorProxy(userTypeId: number): boolean {
		const franchiseOperatorProxy = [USER_TYPES.FranchiseOperator, USER_TYPES.FranchiseProxy];

		return franchiseOperatorProxy.includes(userTypeId);
	}

	static isFranchiseLiaisonProxyParticipant(userTypeId: number): boolean {
		const franchiseLiaisonProxyParticipant = [
			USER_TYPES.Participant,
			USER_TYPES.FranchiseLiaison,
			USER_TYPES.FranchiseProxy
		];

		return franchiseLiaisonProxyParticipant.includes(userTypeId);
	}

	static isAdvancedAdminUserTypes(userTypeId: number): boolean {
		const advancedAdminUserTypes = [
			USER_TYPES.Administrator,
			USER_TYPES.Advisor,
			USER_TYPES.ApplicationTeam,
			USER_TYPES.ApplicationTeamWithOverride,
			USER_TYPES.PaymentTeamWithOverride,
			USER_TYPES.TuitionSpecialistWithOverride,
			USER_TYPES.SystemAdmin,
			USER_TYPES.SystemAdminWithOverride
		];

		return advancedAdminUserTypes.includes(userTypeId);
	}
}
